export function downloadAsJSON(data: any, name: string) {
    if (!data) return

    const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
        JSON.stringify(data, null, 2)
    )}`
    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", dataStr)
    downloadAnchorNode.setAttribute("download", `${name}.json`)
    document.body.appendChild(downloadAnchorNode)
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
}

export function downloadAsCSV(data: string, name: string) {
    if (!data) return

    /**
     * Note: there is a byte marker at the beginning of this file's
     * content that indicates to file-reading software that the
     * encoding is utf-8. If this is removed some software might
     * incorrectly parse the data in the CSV and/or tests will fail.
     */
    const dataStr = `data:text/csv;charset=utf-8,${encodeURIComponent(
        "\ufeff" + data
    )}`
    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", dataStr)
    downloadAnchorNode.setAttribute("download", `${name}.csv`)
    document.body.appendChild(downloadAnchorNode)
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
}

export async function downloadData(data: any, name: string) {
    if (!data) return

    const dataFetch = await fetch(data, { cache: "no-store" })
    const dataBlob = await dataFetch.blob()
    const dataURL = URL.createObjectURL(dataBlob)

    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", dataURL)
    downloadAnchorNode.setAttribute("download", name)

    document.body.appendChild(downloadAnchorNode)
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
    URL.revokeObjectURL(dataURL)
}

export function downloadDataAsZip(data: Blob, name: string) {
    if (!data) return
    const dataUrl = URL.createObjectURL(data)
    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", dataUrl)
    downloadAnchorNode.setAttribute("download", `${name}.zip`)

    document.body.appendChild(downloadAnchorNode)
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
    URL.revokeObjectURL(dataUrl)
}

export function downloadDataAsZipFromURL(url: string, name?: string) {
    if (!url) return
    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", url)
    if (name) {
        downloadAnchorNode.setAttribute("download", `${name}.zip`)
    }
    document.body.appendChild(downloadAnchorNode)
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
}
